import { MenuData } from '../types';
import { normalizeMenuData } from './menuNormalize';

const triggerDownload = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  window.URL.revokeObjectURL(url);
};

export const exportMenuToJsonFile = (menu: MenuData, filename = 'menu-export') => {
  const normalized = normalizeMenuData(menu);
  const blob = new Blob([JSON.stringify(normalized, null, 2)], { type: 'application/json' });
  triggerDownload(blob, `${filename}.json`);
};

export const importMenuFromJsonFile = async (file: File): Promise<MenuData> => {
  const text = await file.text();
  const parsed = JSON.parse(text);
  return normalizeMenuData(parsed);
};
